export default {
  primary: '#007a63',
  secondary: '#A83BA4',

  green: '#007a63',
  dark: '#1a2936',
  light_dark: '#304353',
  gray: '#7f8e9c',
  light_gray: '#c4c4c4',
  light: '#ffffff',
  white: '#FFFFFF',
  red: 'red',
  warning: '#f6edce',
  warning_dark: '#8b7d32',
  danger: '#f8d7da',
  danger_dark: '#721c24',
  danger_dark_light: '#b17b80',
  danger_border: '#f5c6cb',
  peace: '#d1ecf1',
  peace_dark: '#0c5460',
  peace_border: '#bee5eb',
  lightslategrey: 'lightslategrey',
  midnight_blue: '#145DA0',
  blue: '#2E8BC0',
  light_blue: '#8fc4e3',
  ultra_light_blue: '#cfeafa',
  mirage: '#1A2936',
  silver: '#E3E4E5',
  smoke_white: '#f5f5f8',
  gold: '#FFD700',
  goldenrod: '#DAA520',
  olive_drab: '#7f9c7f',
  dark_khaki: '#9a9c7f',
  tuscany_red: '#9c7f7f',
  light_bluish_gray: '#a4b1bd',

  negative: '#a31212',
  positive: '#007a63',

  heather: '#bbc5d4',
  disabled_color: '#f4f4f4',
  light_shade_of_gray: '#CBCBCB',
  very_light_shade_of_gray: '#DDDDDD'
}
